/* eslint-disable code-style/folder-structure-consistency */

import * as yup from "yup";

import { messagesConstants } from "@/constants";

import { regexData } from "../../data/regex";  

export const adminAndPhotographerFormSchema = yup.object({
    email: yup.string().email(messagesConstants.inputsMsgs.invalidEmail).required(messagesConstants.inputsMsgs.email),
    firstName: yup.string().required(messagesConstants.inputsMsgs.firstName).matches(
        regexData.name,
        messagesConstants.inputsMsgs.invalidName,
    ),
    lastName: yup.string().required(messagesConstants.inputsMsgs.lastName).matches(
        regexData.name,
        messagesConstants.inputsMsgs.invalidName,
    ),
    phoneNumber: yup.string().required(messagesConstants.inputsMsgs.phoneNumber).matches(
        regexData.phoneNumber,
        messagesConstants.inputsMsgs.invalidPhoneNumber,
    ).matches(
        regexData.allDigitsSameNumber,
        messagesConstants.inputsMsgs.invalidPhoneNumber,
    ).matches(
        regexData.incrementingNumbers,
        messagesConstants.inputsMsgs.invalidPhoneNumber,
    ).matches(
        regexData.repeatingPatternTypeOne,
        messagesConstants.inputsMsgs.invalidPhoneNumber,
    ).matches(
        regexData.repeatingPatternTypeTwo,
        messagesConstants.inputsMsgs.invalidPhoneNumber,
    ).test(
        "Phone Number Length",
        messagesConstants.inputsMsgs.invalidPhoneNumber,
        (value) => value.length <= 18,
    ),
});
